import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { ToolScanTreeComponent } from '@app/tool/components';
import * as _ from "lodash";

@Component({
    selector: 'app-maintenance-plan-overview',
    templateUrl: './maintenance-plan-overview.component.html',
    styleUrls: ['./maintenance-plan-overview.component.scss']
})
export class MaintenancePlanOverviewComponent implements OnInit, OnChanges {
    @ViewChild(ToolScanTreeComponent, {static: false}) toolScanTree: ToolScanTreeComponent;

    @Input() maintenancePlan: any;
    @Input() showControls = false;
    @Input() showVersion = false;
    @Input() isLoadingTools = false;
    @Input() hasNavigation = false;
    @Input() detailsView = false;
    @Input() hasNavigationForActivities = false;

    @Output() edit = new EventEmitter<any>();
    @Output() duplicate = new EventEmitter<any>();
    @Output() delete = new EventEmitter<any>();
    @Output() navigate = new EventEmitter<any>();
    @Output() taskClicked = new EventEmitter<any>();

    filter = '';

    filteredTools = [];

    constructor() {
    }

    ngOnInit() {
    }

    ngOnChanges(changes: SimpleChanges) {
        this.filteredTools = this.maintenancePlan.tools;
    }


    init() {
        this.setTools();
        this.setActivities();
    }

    private setTools() {
        this.toolScanTree.items = this.maintenancePlan.tools;
    }

    private setActivities() {
        this.maintenancePlan.items[0].expanded = true;
        for (let i = 1; i < this.maintenancePlan.items.length; i++) {
            this.maintenancePlan.items[i].expanded = false;
        }
    }

    onEdit() {
        this.edit.emit(this.maintenancePlan);
    }

    onDuplicate() {
        this.duplicate.emit(this.maintenancePlan);
    }

    onDelete() {
        this.delete.emit(this.maintenancePlan);
    }

    onTaskClicked(event: any) {
        this.taskClicked.emit(event);
    }

    onNavigate() {
        this.navigate.emit(this.maintenancePlan);
    }

    onSearch(event: string) {
        this.filter = event;
        this.filteredTools = (this.maintenancePlan.tools || [] as any[]).filter(
            tool => tool.name.toLowerCase().includes(this.filter.toLowerCase())
        );
    }

    get activities() {
        if (this.hasNavigationForActivities) {
            this.maintenancePlan.items.forEach(item => {
                item.hasNavigation = true;
                item.link = `tool-maintenance-plans/activities/${item.id}/details`;
            });
        }

        return this.maintenancePlan.items;
    }
}
